import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";

function MobilePrefill() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const columns = [
    { key: "personal_information", label: "Personal Information" },
    { key: "alternate_phone", label: "Alternate Phone" },
    { key: "email", label: "Email" },
    { key: "address", label: "Address" },
    { key: "document_data", label: "Document Data" },
  ];

  const getFieldValue = (key) => {
    if (!apiResponse) return "";
    if (apiResponse.personal_data && apiResponse.personal_data[key] !== undefined) {
      return apiResponse.personal_data[key];
    }
    if (apiResponse[key] !== undefined) {
      return apiResponse[key];
    }
    return "";
  };

  const renderCellContent = (key, value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }

    if (key === "personal_information") {
      return (
        <div style={{ fontSize: "14px", lineHeight: "1.5" }}>
          {value.full_name && <div><strong>Name:</strong> {value.full_name}</div>}
          {value.gender && <div><strong>Gender:</strong> {value.gender}</div>}
          {value.age && <div><strong>Age:</strong> {value.age}</div>}
          {value.date_of_birth && <div><strong>DOB:</strong> {value.date_of_birth}</div>}
        </div>
      );
    }

    if (key === "alternate_phone") {
      if (Array.isArray(value)) {
        return (
          <ul style={{ margin: 0, paddingLeft: "15px", fontSize: "14px" }}>
            {value.map((item, index) => (
              <li key={index}>{item.value || String(item)}</li>
            ))}
          </ul>
        );
      }
    }

    if (key === "email") {
      if (Array.isArray(value)) {
        return (
          <ul style={{ margin: 0, paddingLeft: "15px", fontSize: "14px", wordBreak: "break-all" }}>
            {value.map((item, index) => (
              <li key={index}>{item.value || String(item)}</li>
            ))}
          </ul>
        );
      }
    }

    if (key === "address") {
      if (Array.isArray(value)) {
        return (
          <ol style={{ margin: 0, paddingLeft: "15px", fontSize: "13px" }}>
            {value.map((item, index) => (
              <li key={index} style={{ marginBottom: "8px" }}>
                <div>{item.detailed_address}</div>
                <div style={{ color: "#666", fontSize: "12px" }}>
                  State: {item.state} | Pincode: {item.pincode} 
                  {item.date_of_reporting && ` | Reported: ${item.date_of_reporting}`}
                </div>
              </li>
            ))}
          </ol>
        );
      }
    }

    if (key === "document_data") {
      if (typeof value === "object") {
        return (
          <div style={{ fontSize: "14px" }}>
            {Object.entries(value).map(([docType, docList]) => {
              if (Array.isArray(docList)) {
                return (
                  <div key={docType} style={{ marginBottom: "5px" }}>
                    <strong style={{ textTransform: "uppercase" }}>{docType}: </strong>
                    {docList.map((doc) => doc.value || String(doc)).join(", ")}
                  </div>
                );
              }
              return null;
            })}
          </div>
        );
      }
    }

    if (typeof value === "object") {
      return (
        <pre style={{ margin: 0, whiteSpace: "pre-wrap", backgroundColor: "transparent", border: "none", fontSize: "12px" }}>
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    }

    return String(value);
  };

  const submit = () => {
    if (!mobileNumber) {
      setErrorMsg("Please enter a mobile number.");
      return;
    }
    setErrorMsg("");
    setLoading(true);
    setApiResponse(null);

    const myHeaders = new Headers();
    myHeaders.append("authorizationToken", "DGGQfUc7WQ5774K0");
    myHeaders.append("x-api-key", "WY7CSBoKCF9egQf4Z7PXgUn4bAot6njVb9WhUI80");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      mobile_number: mobileNumber,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://rkw56tzro7.execute-api.ap-south-1.amazonaws.com/default/mobileprefill",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setApiResponse(result);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setErrorMsg("Something went wrong with the server.");
        setLoading(false);
      });
  };

  return (
    <div className="container containerBoreder">
      <h2 className="pageTitle">Profile Fetch by Mobile</h2>
      <div className="row mb-3">
        <div className="col-12 col-md-6">
          <input
            type="text"
            className="form-control"
            placeholder="Mobile Number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12">
          {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
          {!loading ? (
            <button className="btn btn-primary" onClick={submit}>
              Submit
            </button>
          ) : (
            <ReactBootStrap.Spinner animation="border" />
          )}
        </div>
      </div>
      <br />

      {apiResponse && (
        <div className="mt-4">
          {(apiResponse.remark || apiResponse.error || apiResponse.message) ? (
            <div className={`alert ${apiResponse.status == 1 ? "alert-success" : (apiResponse.error || apiResponse.message ? "alert-danger" : "alert-warning")} mb-3`} role="alert">
              {apiResponse.error || apiResponse.message || apiResponse.remark}
            </div>
          ) : null}
          {(apiResponse.status == 1 || apiResponse.personal_data) && (
            <>
              <b>Profile Result:</b>
              <div className="table-responsive mt-2">
                <table className="table table-bordered table-striped">
                  <thead className="thead-light">
                    <tr>
                      {columns.map((col) => (
                        <th key={col.key}>{col.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {columns.map((col) => {
                        const value = getFieldValue(col.key);
                        return (
                          <td key={col.key}>
                            {renderCellContent(col.key, value)}
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MobilePrefill;

